import api from 'services/api'
import {
  GET_COMPLAINTS_LIST,
  DELETE_COMPLAINT,
  CREATE_COMPLAINT,
  UPDATE_COMPLAINT,
  GET_COMPLAINT_DETAIL,
  ADD_COMPLAINT_IMAGE,
  GET_COMPLAINT_TYPES_LIST,
  ASSIGN_COMPLAINT,
  REPLY_COMPLAINT,
} from '../endpoints'

export const getComplaintsList = async (body) => await api.post(GET_COMPLAINTS_LIST, body)
export const deleteComplaint = async (id) => await api.delete(DELETE_COMPLAINT, {data: {id}})
export const getComplaintDetail = async (id) => await api.get(`${GET_COMPLAINT_DETAIL}?id=${id}`)

export const submitComplaint = async (values, id) =>
  await api.post(id ? UPDATE_COMPLAINT : CREATE_COMPLAINT, values)

export const addComplaintImage = async (id, values) =>
  await api.post(`${ADD_COMPLAINT_IMAGE}?id=${id}`, values, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

export const assignComplaint = async (body) => await api.post(ASSIGN_COMPLAINT, body)

export const replyComplaint = async (body) =>
  await api.post(REPLY_COMPLAINT, body, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

// Complaint Types
export const getComplaintTypesList = async () => await api.get(GET_COMPLAINT_TYPES_LIST)
